import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginInput = _resolveComponent("LoginInput")!
  const _component_DialogFrame = _resolveComponent("DialogFrame")!

  return (_ctx.isDialogOpen)
    ? (_openBlock(), _createBlock(_component_DialogFrame, {
        key: 0,
        onClickBackground: _ctx.onClose
      }, {
        default: _withCtx(() => [
          (_ctx.isUserOpen || _ctx.getPreviousRoute())
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
              }, "×"))
            : _createCommentVNode("", true),
          _createVNode(_component_LoginInput, {
            title: _ctx.title,
            requestLogin: _ctx.requestLogin,
            ref: "login",
            onUserLogined: _ctx.onUserLogin,
            onOnClickLink: _ctx.close
          }, null, 8, ["title", "requestLogin", "onUserLogined", "onOnClickLink"])
        ]),
        _: 1
      }, 8, ["onClickBackground"]))
    : _createCommentVNode("", true)
}